import PlayableFlamingo from './PlayableFlamingo.js';
// import AxL from "./axl.js";
import AxL from "./axl_obfuscated.js";

const axl = new AxL();

export default class App {

  constructor() {

    let flamingo;


    axl.handshake().then((params) => {

      flamingo = new PlayableFlamingo(axl);

      if(params.hasOwnProperty('level')){
        flamingo.levelName = params["level"];
      }
      flamingo.initUI();
      flamingo.initBeforeLaunch();


      console.log("handshake complete");
    });



    let firstResume = true;
    axl.registerMessageCallback(AxL.HostToChild.RESUME, () => {
      if (firstResume) {
        firstResume = false;
        flamingo.didFirstResume = true;

        // Sandbox just became visible, run the intro / start the game / etc.
        // flamingo.initWorld();
        flamingo.handleAxlFirstResume();


      } else {
        // The user is returning after a break! Resume videos, play sounds
        // and melt down the GPU!
        flamingo.handleAxlResume();
      }
    });

    axl.registerMessageCallback(AxL.HostToChild.FREEZE, () => {
      // Pause videos, mute audio, stop super fancy GPU shaders;
      flamingo.handleAxlFreeze();
    });

  }


}
